export const CHECKOUT_MESSAGES = {
  pageTitle: 'Finalizar Compra',
  postPaymentNoticeTherapist: {
    ariaLabel: 'Informação após o pagamento para consteladores',
    message:
      'Após o pagamento você receberá um e-mail com a confirmação e um tutorial de uso da plataforma.',
  },
  postPaymentNoticeParticipant: {
    ariaLabel: 'Informação após o pagamento',
    message: 'Após o pagamento você receberá um e-mail com a confirmação.',
  },
  loginSection: {
    title: 'Quase lá! Entre ou crie sua conta',
    description:
      'Seus dados de pagamento já estão preenchidos. Faça login ou crie uma conta para concluir a compra.',
  },
  identity: {
    title: 'Identificação para finalizar',
    description: 'Informe seu email para vincular esta compra sem sair desta página.',
    emailLabel: 'Email',
    emailPlaceholder: 'voce@exemplo.com',
    continueButton: 'Continuar',
    validatingButton: 'Validando...',
    checkingEmailButton: 'Verificando email...',
    resolveError: 'Não foi possível validar seu email no momento. Tente novamente.',
    resolveSuccess: 'Email validado. Você já pode concluir o pagamento.',
    checkEmailError: 'Não foi possível verificar o email no momento. Tente novamente.',
    newUserPrompt: 'Não encontramos cadastro para este email. Confirme o email para continuar.',
    confirmEmailLabel: 'Confirmar email',
    confirmEmailPlaceholder: 'repita seu email',
    confirmEmailMismatch: 'Os emails informados não coincidem.',
    passwordHint: 'Crie uma senha para acessar a plataforma após a compra.',
    passwordLabel: 'Senha *',
    confirmPasswordLabel: 'Confirmar senha *',
    passwordMismatch: 'As senhas não coincidem.',
    passwordRequired: 'Informe e confirme sua senha (mínimo 6 caracteres).',
    existingUserReady:
      'Encontramos uma conta com este email. Clique em Continuar para liberar o pagamento PIX.',
    loggedInPixTitle: 'Comprando com sua conta',
    loggedInPixDescription: (email: string) =>
      `O pagamento será vinculado ao email ${email}. Para usar outro email, saia da conta antes de concluir a compra.`,
  },
  success: {
    existingUser: 'Entrar na conta',
    newUserWithPassword: 'Entrar agora',
    newUserPasswordPending: 'Definir senha',
  },
  validation: {
    invalidDocument: 'Informe um CPF ou CNPJ válido.',
    zipRequired: 'Informe um CEP válido com 8 dígitos.',
    zipInvalid: 'CEP não encontrado. Verifique e tente novamente.',
    zipLookupError: 'Não foi possível validar o CEP. Tente novamente em instantes.',
    zipHint: 'Validamos seu CEP automaticamente.',
    zipValid: 'CEP válido.',
    termsRequired: 'Você precisa aceitar os Termos de Serviço e a Política de Privacidade para concluir a compra.',
  },
  terms: {
    prefix: 'Li e concordo com os',
    termsLink: 'Termos de Serviço',
    and: 'e a',
    privacyLink: 'Política de Privacidade',
  },
  zipSection: {
    title: 'CEP',
    label: 'CEP',
  },
  founder: {
    sectionLabel: 'Idealizadora da plataforma',
    name: 'Erica Coscioni',
    photoAlt: 'Erica Coscioni, idealizadora da Constela Brasil',
    role: 'Idealizadora',
    tagline:
      '“Para além da tecnologia, existe uma história, um propósito e o desejo sincero de tocar vidas através da constelação.”',
  },
  platform: {
    sectionLabel: 'Prévia da plataforma Constela Brasil',
    eyebrow: 'A plataforma',
    title: 'Ambiente virtual para constelação online',
    imageAlt: 'Ambiente virtual de reunião Constela Brasil com avatares 3D e vídeo dos participantes',
    caption: 'Atendimento que encanta e gera indicações.',
  },
  planDetails: {
    descriptionLabel: 'Sobre este plano',
    includesLabel: 'O que está incluído',
    featuredBadge: 'Destaque',
    periodLabel: 'Período',
    typeLabel: 'Tipo',
    typeRecurring: 'Assinatura recorrente',
    typeOneTime: 'Pagamento único',
    sessionLabel: 'Modalidade',
    paymentMethodLabel: 'Método',
    paymentCard: 'Cartão de crédito',
    paymentPix: 'PIX',
    moreFeatures: (count: number) =>
      count === 1 ? '+ 1 benefício adicional neste plano' : `+ ${count} benefícios adicionais neste plano`,
  },
};
